// Actions
export const API_RESPONSE_SUCCESS = "API_RESPONSE_SUCCESS";
export const API_RESPONSE_ERROR = "API_RESPONSE_ERROR";
export const GET_EVENEMENTS = "GET_EVENEMENTS";

// Add EVENEMENT
export const ADD_NEW_EVENEMENT = "ADD_NEW_EVENEMENT";
export const ADD_EVENEMENT_SUCCESS = "ADD_EVENEMENT_SUCCESS";
export const ADD_EVENEMENT_FAIL = "ADD_EVENEMENT_FAIL";

// Edit EVENEMENT
export const UPDATE_EVENEMENT = "UPDATE_EVENEMENT";
export const UPDATE_EVENEMENT_SUCCESS = "UPDATE_EVENEMENT_SUCCESS";
export const UPDATE_EVENEMENT_FAIL = "UPDATE_EVENEMENT_FAIL";
